module.exports = __webpack_public_path__ + "img/Mage-undead-f-70.41121496.gif";